/* ============
 * Create Page
 * ============
 *
 * This page creates client.
 */

import { mapGetters } from 'vuex';
import adjustmentService from './../../../../../services/adjustment';
import adjustmentTransformer from './../../../../../transformers/adjustment';
import stockService from './../../../../../services/stock';
import warehouseService from './../../../../../services/warehouse';
import Forms from './../../../../../utils/forms/forms';
import productService from './../../../../../services/product';
import store from './../../../../../store';

export default {
  data() {
    return {
      formBasicInformation: new Forms({
        warehouseId: {
          value: '',
          type: 'select',
        },
        adjustmentTypeId: {
          value: '',
          type: 'select',
        },
        reason: {
          value: '',
          type: 'textarea',
        },
      }),
      loading: true,
      tabIndex: 'first',
      fields: {
        productId: {
          value: '',
          type: 'autocomplete',
          attributes: {
            isSearch: true,
            searchMethod: this.searchMethod,
            loading: true,
          },
        },
        batchId: {
          value: '',
          type: 'select',
        },
        currentAdjustment: {
          value: '0',
          type: 'text',
          disabled: true,
        },
        qty: {
          value: '0',
          type: 'text',
        },
      },

      isImport: true,
      isExport: true,
      download: this.downloadProduct,
      server: {
        url: '',

      },
      adjustmentTypeOptions: [],
    };
  },

  computed: {
    ...mapGetters({
      currentStockProducts: 'currentStockProductsCustom',
      /* stocks: 'allStocks',*/
      warehouses: 'allWarehouses',
      currentAdjustment: 'currentAdjustment',
    }),

    isSharedToYou() {
      const data = this.warehouses.items.filter(item => item.id === this.formBasicInformation.warehouseId);
      if (data.length > 0) {
        return data[0].isSharedToYou;
      }
      return false;
    },

  },

  watch: {

    'formBasicInformation.adjustmentTypeId': function (adjustmentTypeId) {
      this.renameLabel(adjustmentTypeId);
    },

    warehouses(warehouses) {
      this.formBasicInformation.setOptions('warehouseId', warehouses.items.map(item => ({ id: item.id, name: item.name + (item.isLocked ? this.$t('static.warehouse.info.locked') : ''), disabled: item.isLocked })));
    },
    'formBasicInformation.warehouseId': function (warehouseId) {
      this.server = {
        url: `${process.env.API_LOCATION}/adjustments/${this.formBasicInformation.warehouseId}/import-product?token=${localStorage.getItem('id_token')}`,
        process: {
          onload: (res) => {
            const name = 'inventory.stock.edit';
            // select the right value in the response here and return
            // return res;
            const obj = JSON.parse(res);
            console.log(obj);
            //   this.$router.push({
            //   name,
            //   params: { id: obj.id },
            // });
          },
        },
      };
      store.dispatch('setStockSelectedWarehouse', warehouseId);
      this.initCurrentAdjustment(this.currentAdjustment);
    },
    currentAdjustment(currentAdjustment) {
      this.initCurrentAdjustment(currentAdjustment);
    },
    /*stocks: function(stocks){

      this.formBasicInformation.setOptions('stockId',stocks.items.map(c => (
        { id: c.id, name: c.code }
      )));
    },*/
    /*'formBasicInformation.stockId': function(stockId){
      const stock =  this.stocks.items
       .filter(p => p.id.toString() === stockId);

       if(stock.length > 0){
         var stockSelected = stock[0];
         var stocksProducts = new Array();
         for(var i = 0; i < stockSelected.products.length; i++){
              stocksProducts.push(stockSelected.products[i].product);
         }
        store.dispatch('fetchAllProducts', stocksProducts);
         console.log(stocksProducts);
       }

    }*/
  },
  created() {
    this.loading = false;
  },

  methods: {

    renameLabel(adjustmentTypeId) {
      let type = '';
      this.adjustmentTypeOptions.forEach((item) => {
        if (parseInt(item.id) === parseInt(adjustmentTypeId)) {
          type = item.name;
          return;
        }
      });

      if (type === 'Wastage' || type === 'Destruction') {
        jQuery('.th-qty').text(this.$t('table.adjustment.products.qty.customDeduct'));
      } else {
        jQuery('.th-qty').text(this.$t('table.adjustment.products.qty.label'));
      }
    },

    /** every time change of warehouse this will be triggered */
    initCurrentAdjustment(currentAdjustment) {
      const me = this;
      let currentQty = 0;
      const data = this.currentAdjustment.products.map((c) => {
        c.product.warehouses.forEach((item) => {
          if (parseInt(me.formBasicInformation.warehouseId) === parseInt(item.warehouseId)) {
            currentQty = item.currentQty;
            return;
          }
        });

        return {
          currentAdjustment: currentQty,
          qty: c.qty,
          id: c.product.id,
          productId: c.product,
          batchId: c.batchId,
        };
      });

      console.log(currentAdjustment.products);
      store.dispatch('allCurrentStockProductsCustom', data);
    },

    /**
     * Method to store the client
     */
    store() {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const client = adjustmentTransformer.send(
        Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts, type: 1 })
      );
      adjustmentService.update(this.$route.params.id, client)
        .then(() => {
          this.$message({
            message: this.$t('static.adjustment.create.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'inventory.adjustment.index',
          });
        }).catch((errors) => {
          this.formBasicInformation.loading = false;
          this.formBasicInformation.recordErrors(errors);
          const message = errors.message;
          if (errors.message) {
            this.$message({
              showClose: true,
              message,
              customClass: 'error',
            });
          }
        });
    },

    saveDraft() {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const client = adjustmentTransformer.send(
        Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts, type: 1 })
      );
      adjustmentService.updateDraft(this.$route.params.id, client)
        .then(() => {
          this.$message({
            message: this.$t('static.adjustment.draft.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'inventory.adjustment.index',
          });
        }).catch((errors) => {
          this.formBasicInformation.loading = false;
          this.formBasicInformation.recordErrors(errors);
          const message = errors.message;
          if (errors.message) {
            this.$message({
              showClose: true,
              message,
              customClass: 'error',
            });
          }
        });
    },
    searchMethod(search, field) {
      return Promise.all([
        productService.searchAll({ search }),
      ]);
    },
    downloadProduct() {
      adjustmentService.downloadProduct(this.formBasicInformation.warehouseId);
    },

    deleteDraft() {
      const me = this;
      this.$confirm(this.$t('static.adjustment.draft.deleteMessage'), 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        me.formBasicInformation.loading = true;
        adjustmentService.destroy(this.$route.params.id).then(() => {
          me.$router.push({
            name: 'inventory.adjustment.index',
          });
        });
      }).catch(() => {

      });
    },
  },
  mounted() {
    this.loading = true;
    store.dispatch('allCurrentStockProductsCustom', []);
    Promise.all([
      warehouseService.all(),
      adjustmentService.show(this.$route.params.id),
      adjustmentService.adjustmentType(),
    ]).then((data) => {
      store.dispatch('setStockSelectedWarehouse', 0);
      this.formBasicInformation.assignData(data[1]);
      this.adjustmentTypeOptions = data[2].map(item => ({
        id: item.id,
        name: this.$t(`form.adjustment.adjustmentTypeList.${item.name.toLowerCase()}`),
      }));
      this.formBasicInformation.setOptions('adjustmentTypeId', this.adjustmentTypeOptions);
      const self = this;
      setTimeout(() => { self.renameLabel(data[1].adjustmentTypeId); }, 500);
      this.loading = false;
    });
  },
  components: {
    VForm: require('./../../../../../components/form/form.vue'),
    VProductsTable: require('./../../../../../components/productTableWithCustomForm/productTableWithCustomForm.vue'),
    VMessage: require('./../../../../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/adjustment/stock/edit/edit.js